import { ApeironSsoLoginType as M, ApeironSsoEvent as pe } from "../../../auth-lib/constants/apeironSso.js";
import $e from "../../../auth-lib/hooks/useApeironSsoCookieHandler.js";
import { useFrontendConfigContext as qe } from "../../../config-lib/contexts/FrontendConfigContext.js";
import { CurrencyTokenType as we } from "../../../currency-lib/constants/currency.js";
import Ke from "../../../currency-lib/hooks/graphql/useGetCurrencyInfo.js";
import ze from "../../../currency-lib/hooks/graphql/useGetOffChainTokenBalances.js";
import { EmptyFullAccount as F } from "../../constants/account.js";
import { ChainType as ue } from "../../constants/chain.js";
import { ERROR_CODE as Qe } from "../../constants/error.js";
import { GASharedEventCategory as U, GASsoProviderMapping as Ve } from "../../constants/googleAnalytics.js";
import { LocalStorageKey as K } from "../../constants/storage.js";
import { useAdeptusContext as Xe } from "../adeptus/AdeptusContext.js";
import { useLogicControlContext as Ye } from "../share/LogicControlContext.js";
import { useMessageContext as Ze } from "../share/MessageContext.js";
import { CustomError as he } from "../../errors/customError.js";
import et from "../../hooks/analytics/useGoogleTagManager.js";
import tt from "../../hooks/errors/useErrorHandler.js";
import ot from "../../hooks/generic/useChainSwitcher.js";
import st from "../../hooks/graphql/useBindWalletAddress.js";
import nt from "../../hooks/graphql/useGetAccountDetail.js";
import at from "../../hooks/graphql/useLoginByEmail.js";
import it from "../../hooks/graphql/useLoginByOAuth.js";
import rt from "../../hooks/graphql/useLoginByWallet.js";
import ct from "../../hooks/graphql/useProcessEmailRegister.js";
import ye from "../../hooks/web3/useWeb3.js";
import { getAccessToken as y, getRefreshToken as g, saveTokens as lt, saveChainType as ft, cleanTokens as mt, cleanChainType as dt, getProvider as ge, AUTH_SESSION_CHANGED as ke } from "../../util/authenication/index.js";
import { sameTokenSession as pt } from "../../util/authenication/token.js";
import { createStrictContext as wt } from "../../util/context/createStrictContext.js";
import { walletRdnsToType as ut } from "../../util/wallet/walletRdnsToType.js";
import { getAccount as Te, watchAccount as ht } from "@wagmi/core";
import * as n from "ramda";
import { useState as u, useCallback as i, useEffect as B } from "react";
import { useTranslation as yt } from "react-i18next";
import Ce from "use-async-effect";
import { isAddress as gt } from "viem";
import { jsx as kt } from "react/jsx-runtime";
const [Tt, oo] = wt("Account"), so = (Ae) => {
  const {
    children: Se
  } = Ae, {
    cleanSession: z,
    correctNetwork: k,
    getBalances: Q,
    walletInstalled: x,
    connectWallet: V
  } = ye(), {
    wagmiConfig: d
  } = ye(), {
    forceLogout: X,
    setForceLogout: Y
  } = Ye(), {
    waitConfig: Z
  } = qe(), {
    inviter: h,
    setWalletAddress: ee,
    handleOnInviteSuccess: te
  } = Xe(), {
    t: G
  } = yt(), {
    detectWalletType: T
  } = ot(), {
    getErrorMessage: I
  } = tt(), {
    setInfo: oe,
    showGeneralError: P
  } = Ze(), {
    mutate: se
  } = st(), {
    mutate: ne
  } = rt(), {
    mutate: ae
  } = at(), {
    loginByOAuth: ie
  } = it(), {
    fetch: W
  } = nt(), {
    fetch: _
  } = Ke(), {
    fetch: re
  } = ze(), {
    mutate: ce
  } = ct(), {
    saveLoginDataToCookie: le,
    clearCookies: ve
  } = $e(), [a, C] = u(F), [f, v] = u(!1), [j, Ee] = u(!1), [Ne, E] = u(null), [Le, H] = u(null), [Oe, R] = u(!1), [Be, Ie] = u(!1), [fe, J] = u(!1), {
    gtmEmitEvent: A,
    gtmConfigUserId: me
  } = et(), de = i(() => {
    C(F);
  }, []), b = i((e) => {
    ee(e || "");
  }, [ee]), D = i(async (e) => {
    if (!e || !gt(e))
      return null;
    const t = await Q(e), {
      grouped: o
    } = await re(), s = await Z();
    let r = {};
    const L = await _((s == null ? void 0 : s.supportToken.allTokens.onChain) || []), w = await _((s == null ? void 0 : s.supportToken.allTokens.offChain) || []);
    return n.isNotNil(r) && (n.forEach((m) => {
      const O = (m == null ? void 0 : m.type) || we.Unspecified, q = n.assoc("amount", t[O] || "0", m);
      r = n.assoc(O, q, r);
    }, n.values(L || {})), n.forEach((m) => {
      const O = (m == null ? void 0 : m.type) || we.Unspecified, q = n.assoc("amount", o[O] || "0", m);
      r = n.assoc(O, q, r);
    }, n.values(w || {}))), r;
  }, [Q, re, Z, _]), S = i(async (e) => {
    let t = n.clone(e);
    const o = await W();
    n.isNotNil(o) && (t = {
      ...o,
      accessToken: y() || "",
      refreshToken: g() || "",
      walletDisplayMode: !0
    });
    const s = await D(t.walletAddress) || {};
    t = {
      ...t,
      balances: s,
      walletDisplayMode: !0
    }, C(t), me(t.id);
  }, [W, me, D]), c = i(async (e) => {
    if (e && (lt(e.accessToken, e.refreshToken), ft(e.accessToken), await S(e), b(e.walletAddress), v(!0), !await k())) {
      const o = T();
      E(o);
    }
  }, [k, T, S, b]), p = i((e) => {
    if (h) {
      const t = n.propOr(!1, "new", e), o = n.pathOr("", ["invitation", "inviter"], e);
      if (t && !n.isEmpty(o)) {
        const s = n.pathOr("", ["invitation", "code"], h);
        n.isEmpty(s) || te();
      }
    }
  }, [te, h]), l = i((e, t, o) => {
    n.isNotNil(e) && le(e, t, o);
  }, [le]), Pe = i(async () => {
    if (!n.isNil(a == null ? void 0 : a.walletAddress) && !n.isEmpty(a == null ? void 0 : a.walletAddress)) {
      const e = await D(a.walletAddress) || {}, t = n.assoc("balances", e, a);
      C(t);
    }
  }, [a, D]), We = i(async () => {
    const e = await W();
    n.isNil(e) || C({
      ...e,
      walletDisplayMode: !0
    });
  }, [W]), Re = i(async () => {
    try {
      const e = await se(null), t = n.isNotNil(e);
      return t && (await c(e), await p(e), l(e.accessToken, M.Ronin)), t;
    } catch (e) {
      return P(I(e)), !1;
    }
  }, [se, I, l, p, c, P]), be = i(async (e) => {
    try {
      const t = await ce({
        email: e.email,
        otpCode: e.otpCode,
        password: e.password,
        enableMarketingEvent: e.marketingMailOption,
        inviter: h
      });
      if (!t)
        throw new he("cannot bind email", Qe.ACCOUNT.BIND_EMAIL_FAIL);
      return oe({
        message: G("account_setting.register_success"),
        confirm: G("common.popup.ok")
      }), await c(t), await p(t), l(t.accessToken, M.Email), t;
    } catch (t) {
      const o = I(t);
      return P(o), null;
    }
  }, [h, G, I, l, p, c, ce, oe, P]), De = i(async (e, t) => {
    const {
      address: o
    } = await V({
      walletType: e,
      networkType: t
    }), s = await ne({
      inviter: h,
      type: e,
      walletAddress: o
    });
    return A(s != null && s.new ? U.SignUp : U.Login, {
      label: "method",
      value: "wallet"
    }), await c(s), await p(s), l(s == null ? void 0 : s.accessToken, M.Ronin, e), s;
  }, [h, V, ne, A, c, p, l]), Me = i(async (e) => {
    const {
      email: t,
      password: o
    } = e, s = await ae({
      email: t,
      password: o
    });
    return A(U.Login, {
      label: "method",
      value: "email"
    }), await c(s), l(s == null ? void 0 : s.accessToken, M.Email), s;
  }, [ae, A, c, l]), Fe = i(async (e) => {
    const {
      authCode: t,
      network: o,
      invitationCode: s,
      redirectURI: r,
      appType: L
    } = e, w = await ie(L, o, r, t, s);
    return A(U.Login, {
      label: "method",
      value: Ve[L]
    }), await c(w), await p(w), l(w == null ? void 0 : w.accessToken, L), w;
  }, [ie, A, c, p, l]), Ue = i((e) => {
    const t = localStorage.getItem(K.SsoState), o = JSON.parse(t || "{}");
    if (!o[e])
      throw new he("invalid sso state");
    return o[e];
  }, []), xe = i(({
    state: e,
    appType: t,
    redirectURI: o,
    currentUrl: s,
    purpose: r
  }) => {
    localStorage.setItem(K.SsoState, JSON.stringify({
      [e]: {
        appType: t,
        redirectURI: o,
        currentUrl: s,
        purpose: r
      }
    }));
  }, []), Ge = i(() => {
    localStorage.removeItem(K.SsoState);
  }, []), _e = (a == null ? void 0 : a.chainType) === ue.Ronin || (a == null ? void 0 : a.chainType) === ue.RoninTestnet, N = i(() => {
    b(""), de(), mt(), dt(), v(!1);
  }, [b, de]), je = i(async () => {
    if (f) {
      const e = T();
      await z(e), N();
    }
  }, [f, T, z, N]), He = i((e) => {
    f ? e() : R(!0);
  }, [f]), $ = i(async () => {
    const e = !!y() || !!g();
    if (v(e), e) {
      const t = ge();
      n.isNotNil(t) && (await x() || (H(t), J(!0)));
    }
    if (y() || g())
      try {
        await S({
          accessToken: y(),
          refreshToken: g()
        });
        const t = n.isNotNil(d) ? Te(d) : null;
        t != null && t.isConnected && (await k() || E(T()));
      } catch (t) {
        console.warn(`cannot get address from metamask, reason: ${t.message}`);
      }
  }, [a.accessToken, a.refreshToken, x]);
  Ce(async () => {
    if (f) {
      const e = ge();
      n.isNotNil(e) && (await x() || (H(e), J(!0)));
    }
    J(!0);
  }, [f]), Ce(async () => {
    if (fe && (y() || g()))
      try {
        await S({
          accessToken: y(),
          refreshToken: g()
        });
        const e = n.isNotNil(d) ? Te(d) : null;
        if (e != null && e.isConnected && !await k()) {
          const o = T();
          E(o);
        }
      } catch (e) {
        console.warn(`cannot get address from metamask, reason: ${e.message}`);
      }
  }, [d, fe]), B(() => {
    const e = () => {
      const t = y() || "", o = g() || "";
      v(!!t || !!o), C((s) => t || o ? {
        ...pt(s.accessToken, t) ? s : F,
        accessToken: t,
        refreshToken: o
      } : F);
    };
    return e(), window.addEventListener(ke, e), window.addEventListener("storage", e), () => {
      window.removeEventListener(ke, e), window.removeEventListener("storage", e);
    };
  }, []), B(() => {
    f && R(!1);
  }, [f]), B(() => {
    X && (Y(!1), N(), R(!0));
  }, [X, N, Y]), B(() => {
    if (n.isNotNil(d)) {
      const e = ht(d, {
        async onChange(t, o) {
          if (t.isConnected !== j && Ee(t.isConnected), !o.isConnecting && t.isConnected && o.chainId !== t.chainId && !await k() && t.connector) {
            const r = ut(t.connector.id);
            E(r);
          }
          a.walletAddress && o.address && t.isDisconnected;
        }
      });
      return () => {
        e();
      };
    }
  }, [d, k, N, a, j]), B(() => (window.addEventListener(pe.SsoLogin, $), () => window.removeEventListener(pe.SsoLogin, $)), [$]);
  const Je = i(async () => {
    await S(a);
  }, [S, a]);
  return /* @__PURE__ */ kt(Tt, {
    value: {
      account: a,
      isLoggedIn: f,
      missWallet: Le,
      showBindWalletPopup: Be,
      showLoginPopup: Oe,
      wrongNetwork: Ne,
      isRoninAccount: _e,
      isWalletConnected: j,
      bindWalletAddress: Re,
      clearLocalSsoState: Ge,
      clearCookies: ve,
      fetchBalances: Pe,
      fetchDetail: We,
      loginByEmail: Me,
      loginByOAuth: Fe,
      loginByWallet: De,
      logout: je,
      requireAuth: He,
      setAccount: C,
      setIsLoggedIn: v,
      setMissWallet: H,
      setShowBindWalletPopup: Ie,
      setShowLoginPopup: R,
      setWrongNetwork: E,
      signUp: be,
      storeSsoState: xe,
      verifyAndGetSsoState: Ue,
      refetchAccountDetail: Je
    },
    children: Se
  });
};
export {
  so as AccountProvider,
  oo as useAccountContext
};
//# sourceMappingURL=AccountContext.js.map
